module.exports = __webpack_public_path__ + "img/37-r.1a84abba.png";